(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.Grid = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Grid = undefined;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var Grid = exports.Grid = function Grid(props) {
    return _react2.default.createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 105 105",
      fill: props.color,
      "aria-label": props.label
    }, _react2.default.createElement("circle", {
      cx: "12.5",
      cy: "12.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "12.5",
      cy: "52.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "100ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "52.5",
      cy: "12.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "300ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "52.5",
      cy: "52.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "600ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "92.5",
      cy: "12.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "800ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "92.5",
      cy: "52.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "400ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "12.5",
      cy: "92.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "700ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "52.5",
      cy: "92.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "500ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), _react2.default.createElement("circle", {
      cx: "92.5",
      cy: "92.5",
      r: props.radius
    }, _react2.default.createElement("animate", {
      attributeName: "fill-opacity",
      begin: "200ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })));
  };
  Grid.propTypes = {
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    color: _propTypes2.default.string,
    label: _propTypes2.default.string,
    radius: _propTypes2.default.number
  };
  Grid.defaultProps = {
    height: 80,
    width: 80,
    color: "green",
    radius: 12.5,
    label: "audio-loading"
  };
});